import {
  ReactElement,
  SyntheticEvent,
  useContext,
  useEffect,
  useState,
} from 'react'
import UserAction from '../../../context/action/UserAction'
import { UserContext } from '../../../context/UserContext'
import DevelopusSnackbarContext from '../../../../../common/ui/snackbar/DevelopusSnackbarContext'
import DevelopusSnackbarActions from '../../../../../common/ui/snackbar/DevelopusSnackbarActions'
import { TabContext, TabPanel } from '@mui/lab'
import { Tab, Tabs } from '@mui/material'
import { t } from 'i18next'
import DevelopusCancelButton from '../../../../../common/ui/button/DevelopusCancelButton'
import DevelopusButton from '../../../../../common/ui/button/DevelopusButton'
import { SaveOutlined } from '@mui/icons-material'
import LicensesView from '../licenses/LicensesView'
import PaymentTransactionsView from '../transactions/PaymentTransactionsView'
import StudentEditForm from './StudentEditForm'

const StudentEdit = (): ReactElement => {
  const snackbarContext = useContext(DevelopusSnackbarContext)
  const snackbarActions = new DevelopusSnackbarActions(snackbarContext)

  const context = useContext(UserContext)
  const action = new UserAction(context)
  const [saveDisabled, setSaveDisabled] = useState<boolean>(true)

  useEffect(() => {
    action.updateStudentFromCurrent()
  }, [])

  useEffect(() => {
    setSaveDisabled(!action.isValid())
  }, [action.isValid()])

  const [tabValue, setTabValue] = useState('info')
  const handleTabChange = (_: SyntheticEvent, newValue: string) => {
    setTabValue(newValue)
  }

  const handleEdit = async (): Promise<void> => {
    try {
      const currentStudent = action.getCurrentStudent()

      if (currentStudent !== undefined) {
        await action.updateStudent()
        snackbarActions.showSnackbar(
          `Student ${currentStudent.getInfo().email} updated`,
        )
        action.refreshStudentsPage()
      }
    } catch (e) {
      console.log(e)
      snackbarActions.showSnackbar(`Can't update`)
    }
  }

  const exit = (): void => {
    action.refreshStudentsPage()
  }

  const showButtons = (): boolean => {
    return !action.isLicenseSelected()
  }

  return (
    <div>
      {showButtons() && (
        <div style={{ position: 'absolute', right: '30px', zIndex: 1000 }}>
          <DevelopusCancelButton text={t('common.cancel')} handleClick={exit} />
          <DevelopusButton
            text={t('common.save')}
            handleClick={handleEdit}
            disabled={saveDisabled}
            icon={<SaveOutlined />}
          />
        </div>
      )}

      <TabContext value={tabValue}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab
            value="info"
            label={t('users.common.information')}
            className="tab-label"
            disabled={action.isLicenseSelected()}
          />
          <Tab
            value="licenses"
            label={t('users.common.licenses')}
            className="tab-label"
            disabled={action.isLicenseSelected()}
          />
          <Tab
            value="paymentTransactionsView"
            label={t('users.common.paymentTransactions')}
            className="tab-label"
            disabled={action.isLicenseSelected()}
          />
        </Tabs>

        <TabPanel value="info">
          <StudentEditForm />
        </TabPanel>
        <TabPanel value="licenses">
          <LicensesView />
        </TabPanel>
        <TabPanel value="paymentTransactionsView">
          <PaymentTransactionsView />
        </TabPanel>
      </TabContext>
    </div>
  )
}

export default StudentEdit
